import { FlagState } from '../libs';

export const FLAG_SUP_FEATURES: FlagState = {
  WEBAPP_RETURN_REQUEST: true,
  epic_ecom_269: false,
  epic_pb_613: false,
  epic_omni_389: false,
  MML_NO_PAYMENT: false,
  epic_omni_677: false,
  epic_ecom_305: false,
  epic_omni_964: true,
  epic_ecom_284: false,
  epic_ecom_460: false,
};
